import React from "react";
import KC_Heading1 from "../../../designsystem/typography/KC-Heading/KC_Heading1";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../designsystem/KC_Button/KC_Button";
import { tt } from "../../../utils/i18n/i18n";
import { useHistory } from "react-router-dom";
import { SIGNUP } from "../../../utils/routes/routes";
import SignUpLayout from "../../18_LoginV2/component/SignUpLayout";

export default function NotFound() {
  const history = useHistory();

  return (
    <SignUpLayout>
      <KC_Heading1 text={tt("notFoundMessage")} className="text-center" />
      <KC_Button
        isTransparent={true}
        size={KC_ButtonSize.Giant}
        type={KC_ButtonType.Button}
        text={tt("returnToHome")}
        className="d-flex"
        onClick={() => {
          history.push(SIGNUP);
        }}
      />
    </SignUpLayout>
  );
}
